export const ROUTES = {
  HOME: '/',
  EXPERIENCE: '/experience',
  PROJECTS: '/projects',
  SKILLS: '/skills',
  EDUCATION: '/education',
  RESUME: '/resume',
  COVER_LETTER: '/coverletter'
};
